import React, { FC } from 'react';

import { Button } from '../../../../../../../button';
import { ErrorProps } from './error.types';
import { Modal } from '../../../../../../../modal/modal.component';
import { ModalIds } from '../../../../../../../../contexts/modals/modals.types';
import { Typography } from '../../../../../../../../../../../components';
import styles from './error.module.scss';
import { useTranslation } from 'react-i18next';

/**
 * Error component
 * @description Content for the Error stage modal of UsersManagement Delete flow
 *
 * @author Oleksii Medvediev
 * @param { ErrorProps } props - ErrorProps defined in the './error.component.tsx'
 * @category Components
 */
const Error: FC<ErrorProps> = ({ onClose }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'management' });

  return (
    <Modal modalId={ModalIds.usersManagementDelete} title={t('modals.usersManagement.delete.error.title')}>
      <div className={styles.wrapper}>
        <Typography.Text variant={'bodyText5'}>{t('modals.usersManagement.delete.error.text')}</Typography.Text>
        <Button type={'button'} variant={'main'} size={'large'} onClick={onClose}>
          <Typography.Text variant={'bodyText2'}>{t('modals.usersManagement.delete.error.continue')}</Typography.Text>
        </Button>
      </div>
    </Modal>
  );
};

export { Error };
